import { FormControl } from 'baseui/form-control'
import { ModalBody, ModalButton, ModalFooter } from 'baseui/modal'
import { ArrowRight } from 'baseui/icon'
import { Spinner } from 'baseui/spinner'
import { useTranslation } from 'react-i18next'
import { useStyletron } from 'baseui'
import usePceSearchV2 from './usePceSearchV2'
import useRetrievePCEsV2 from './useRetrievePCEsV2'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import AddressSelect from '@/containers/SubscriptionFormPageNew/Components/shared/AddressSelect/AddressSelect'

const PceSearchForm = () => {
  const { t } = useTranslation()
  const [css] = useStyletron()
  const {
    getAddress,
    getOccupant,
    getSerialNumber,
    getStreetNumber,
    getStreetName,
    isFormFilled,
    isLoading,
    updatePceConfigData,
    updateAddressHandler,
  } = usePceSearchV2()
  const { searchPCEs } = useRetrievePCEsV2()

  return (
    <>
      <ModalBody>
        <div className={css({ padding: '1rem 0' })}>
          <AddressSelect
            currentValue={getAddress}
            onChange={updateAddressHandler}
            disabled={isLoading}
            placeholder={t('subscriptionTools:pce_search.fields.address')}
          />
          <div
            className={css({
              display: 'flex',
              gap: '1rem',
              alignItems: 'center',
              marginBottom: '1rem',
            })}
          >
            <div className={css({ flex: '1 1 30%' })}>
              <SDInput
                currentValue={getStreetNumber}
                outerOnchange={value => updatePceConfigData({ address: { ...getAddress, streetNumber: value } })}
                placeholder={t('subscriptionForm:address_module.street_number')}
              />
            </div>
            <div className={css({ flex: '1 1 70%' })}>
              <SDInput
                currentValue={getStreetName}
                outerOnchange={value => updatePceConfigData({ address: { ...getAddress, streetName: value } })}
                placeholder={t('subscriptionForm:address_module.street_name')}
              />
            </div>
          </div>

          <FormControl>
            <SDInput
              placeholder={t('subscriptionTools:pce_search.fields.occupant')}
              currentValue={getOccupant}
              outerOnchange={value => updatePceConfigData({ occupant: value || '' })}
              disabled={isLoading}
            />
          </FormControl>

          <FormControl>
            <SDInput
              placeholder={t('subscriptionTools:pce_search.fields.serial_number')}
              currentValue={getSerialNumber}
              outerOnchange={value => updatePceConfigData({ serialNumber: value || '' })}
              disabled={isLoading}
            />
          </FormControl>
        </div>
      </ModalBody>

      <ModalFooter
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#f7f7f7',
          borderTop: '0.0625rem solid #e0e0e0',
          padding: '1rem 1.5rem',
        }}
      >
        <ModalButton
          id='button-start-search'
          endEnhancer={() => <ArrowRight size={24} />}
          disabled={!isFormFilled || isLoading}
          onClick={searchPCEs}
        >
          {t('subscriptionTools:pce_search.start_search')}
        </ModalButton>
        {isLoading && <Spinner size={24} />}
      </ModalFooter>
    </>
  )
}

export default PceSearchForm
